<template>
  <div>
    <div
      class="sub-header"
      data-test="sub-header"
    >
      Fundraiser Image
    </div>
    <div class="overflow-y-scroll scrollbar modal-height">
      <h5
        class="helping-text inputs details"
        data-test="helping-text"
      >
        Adding your profile image fosters a personal connection, inspiring trust and empathy among potential donors.
        Research shows that familiar faces increase the likelihood of donations.
      </h5>
      <div class="inputs">
        <ImageUpload
          :minSize="400"
          :maxSize="1024"
          @uploaded="
            (data) => {
              fundraiserStore.image = data;
            }
          "
          data-test="image-upload"
        />
        <div
          class="error-message"
          data-test="error-message"
        >
          {{ fundraiserStore.errors.image }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useFundraiserStore } from '@/stores/FundraiserStore.js';
import { useDonorStore } from '@/stores/DonorStore.js';
import ImageUpload from '@/components/forms/ImageUpload.vue';

const fundraiserStore = useFundraiserStore();
const donorStore = useDonorStore();

const mainColor = donorStore.mainColor;
</script>

<style scoped>
.upload-container {
  width: 100%;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  border: 1px dashed var(--p-primary-500);
  cursor: pointer;
  text-align: center;
  margin-bottom: 8px;
}

.helping-text {
  margin-bottom: 24px;
}

.upload-cloud {
  width: 40px;
  height: 40px;
  margin-bottom: 10px;
}

.upload-text {
  font-size: 14px;
}

.image-upload {
  display: none;
}

.preview-image {
  max-width: 200px;
  max-height: 200px;
  z-index: 2;
}

.error-message {
  color: red;
  margin-bottom: 10px;
}

.info-text {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  font-size: 0.875em;
  font-weight: 400;
  color: #54698d;
  margin-bottom: 8px;
}
.details {
  text-align: left;
}
@media screen and (max-width: 768px) {
  .details {
    text-align: center;
  }
}
</style>
